/// <reference path="../../../Common/Helpers/GridEditorBase.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerEditor()
    export class DataReportColumnListEditor extends Common.GridEditorBase<DataReportColumn> {
        protected getColumnsKey() { return "Data.DataReportColumnList" };
        protected getDialogType() { return DataReportColumnDialog; }

        protected getAddButtonCaption() {
            return "Add Column";
        }

        protected getButtons() {
            var buttons = super.getButtons();

            var addIndex = Q.indexOf(buttons, x => x.cssClass == "add-button");
            buttons[addIndex].icon = 'fa-plus';

            buttons.push({
                title: 'Update Columns',
                cssClass: 'update-columns-button',
                icon: 'fa-refresh',
                onClick: () => this.updateColumns && this.updateColumns()
            });

            return buttons;
        }

        public updateColumns: () => void;

        validateEntity(row, id) {
            return true;
        }
    }
}